var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"background-container darken"},[_c('div',{staticClass:"welcome-text"},[_vm._v(" Welcome To The Phantasy Phootball League Page! ")])])])
}]

export { render, staticRenderFns }